import { parseAppData } from './parse-app-data';
import type { AppData, BridgeOptions } from './types';
import { BRIDGE_TIMEOUT_MS } from './types';

export async function readAppData({
	onError,
}: BridgeOptions): Promise<AppData> {
	let isSettled = false;
	let timer: ReturnType<typeof setTimeout> | undefined;
	const read = async () => {
		try {
			const result = window.IxiWebView?.getAppData
				? window.IxiWebView.getAppData()
				: window.webkit?.messageHandlers?.appInterface?.postMessage(
						'getAppData',
					);
			// Reply-capable iOS hosts may return a promise; older handlers return
			// void and supply the context via launch query/cookies instead.
			return parseAppData(await result);
		} catch {
			if (!isSettled)
				onError({
					stage: 'app-data',
					reason: 'Unable to read native app data',
				});
			return {};
		}
	};
	return Promise.race([
		read(),
		new Promise<AppData>((resolve) => {
			timer = setTimeout(() => {
				onError({ stage: 'app-data', reason: 'Native app data timed out' });
				resolve({});
			}, BRIDGE_TIMEOUT_MS);
		}),
	]).finally(() => {
		isSettled = true;
		clearTimeout(timer);
	});
}
